import { Heading } from 'components/chroma';
import React, { FunctionComponent } from 'react';

export const AccountCreatedHeader: FunctionComponent<{ fontSize: number }> = ({
  fontSize,
}) => <Heading size={fontSize}>Online Insurance Service Centre</Heading>;

export default AccountCreatedHeader;
